import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly translateService = inject(TranslateService);

  private readonly navigationItems = signal<MenuItem[]>([
    {
      label: this.translateService.instant('app.navigation.dashboard'),
      icon: 'pi pi-th-large',
      routerLink: '/dashboard',
    },
    {
      label: this.translateService.instant('app.navigation.myCompany'),
      icon: 'pi pi-building',
      routerLink: '/organization',
    },
    {
      label: this.translateService.instant('app.navigation.documents'),
      icon: 'pi pi-file',
      routerLink: '/documents',
    },
    {
      label: this.translateService.instant('app.navigation.invitations'),
      icon: 'pi pi-envelope',
      routerLink: '/invitations',
    },
  ]);

  getNavigationMenuItems(): WritableSignal<MenuItem[]> {
    return this.navigationItems;
  }
}
